import { type ProductDetailsStickSingleFlavor } from "@jti/fe-common";

import { type ConsumableMatrixItem } from "@product-details/containers/ConsumablesProductDetailsContainer/ConsumablesProductDetailsContainer.types";

export const isConsumableMatrixItem = (
  consumable: ProductDetailsStickSingleFlavor | ConsumableMatrixItem
): consumable is ConsumableMatrixItem => "flavorFamily" in consumable;
